import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import SignaturePad from 'react-signature-pad-wrapper'
import {

  CURRENTPAYSLIPS_URL,
  EMPLOYEES_BASE_URL,
  WAREHOUSES_BASE_URL,


} from '../config';
import axios from 'axios';


// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from '../config';
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import ClubHeader from './ClubHeader';



// Hook
import useAuth from '../hooks/useAuth';

import { useEmployeeListFetch } from '../hooks/useEmployeeList';
import { usePayTypesListFetch } from '../hooks/usePayTypesListFetch';
import { usePayratesListFetch } from '../hooks/usePayratesListFetch';
import { useAdditionsListFetch } from '../hooks/useAdditionsListFetch';
import { useCurrentPayslipFetch } from '../hooks/useCurrentPayslipFetch';
import { useCurrentPayrunListFetch } from '../hooks/useCurrentPayrunListFetch';
// Image

import Grid from './Grid';
import Display from './Display';
import PdfComp from './PdfComp';
import Sidepanel from './SidePanel';




const CurrentPayslip = () => {



  const auth = useAuth();
  const { id } = useParams()
  const location = useLocation();
  const navigate = useNavigate()
  console.log(id)
  const { state, loading, error, setSearchValue, setIncludeInactive, setLoading, setTrigger } = useEmployeeListFetch();
  const { currentPayslipstate, currentPayslipsetState, currentPaysliploading, currentPaysliperror, currentPayslipsetLoading, currentPayslipsetTrigger } = useCurrentPayslipFetch(id);
  const { currentPayrunliststate, currentPayrunlistloading, currentPayrunlisterror, currentPayrunlistsearchValue, currentPayrunlistSetSearchValue, setcurrentPayrunlistIncludeInactive, fetchCurrentPayrunlists, setcurrentPayrunlistTrigger } = useCurrentPayrunListFetch()
  const { paytypestate, paytypeloading, paytypeerror, paytypesearchValue, paytypesetSearchValue, paytypesetIncludeInactive, fetchPayTypesList } = usePayTypesListFetch();
  const { payratestate, payrateloading, payrateerror, payratesearchValue, payratesetSearchValue, payratesetIncludeInactive, fetchPayratesList } = usePayratesListFetch();
  const { additionstate, additionloading, additionerror, additionsearchValue, additionsetSearchValue, additionsetIncludeInactive, fetchAdditionsList } = useAdditionsListFetch();
  const [pdffile, setPdfFile] = useState(null)
  const [newPayslip, setNewPayslip] = useState(false)
  const [edit, setEdit] = useState(false)
  const from = location.currentPayslipstate?.from || "./";
  console.log("from = " + from)
  const [payOpen, setPayOpen] = useState(false)
  const [additionOpen, setAdditionOpen] = useState(false)
  const [deductionOpen, setDeductionOpen] = useState(false)
  const [contractsOpen, setContractsOpen] = useState(false)
  const [duplicate, setDuplicate] = useState(false)
  const [idOpen, setIdOpen] = useState(false)
  const [otherOpen, setOtherOpen] = useState(false)
  const [grandTotal, setGrandTotal] = useState(0);
  const [additionTotal, setAdditionTotal] = useState(0);
  const [deductionTotal, setDeductionTotal] = useState(0);
  const [tax, setTax] = useState(0);
  const [uif, setUif] = useState(0);
  const [netpay, setNetpay] = useState(0);
  const form = useForm()
  const { register, control, watch, handleSubmit, formState, reset, setValue } = form
  const { errors } = formState
  const [errMessage, setErrMessage] = useState("");
  const username = auth.auth.user.username
  const access = auth.auth.user.userRole
  const accessToken = auth.auth.accessToken

  const paytypes = watch("standardPayslip.paytypes");
  const basePayRate = watch("basepayrate");

  // console.log(besluit.besluit[0].besluit)



  console.log(currentPayslipstate)
  console.log(payratestate)

  useEffect(() => {

    if (id === "newid") {
      setNewPayslip(true)
    }

  }, [id])

  useEffect(() => {
    if (currentPayslipstate?.paytypes) {
      reset({ standardPayslip: currentPayslipstate }); // Reset form values when currentPayslipstate updates

      currentPayslipstate.paytypes.forEach((type, index) => {
        setValue(`paytypes.${index}.paytype`, type.paytype?._id);
        setValue(`paytypes.${index}.normalHours`, type.normalHours);
        if (type.payrate) {

          console.log(type.payrate)
          setValue(`paytypes.${index}.payrate`, type.payrate._id)
        } else {


          console.log(currentPayslipstate.employee)

          if (currentPayslipstate.employee.baserate && payratestate?.payrates?.length) {

            const foundRate = payratestate.payrates.find(value => value.code === currentPayslipstate.employee.baserate);
            if (foundRate) {
              setValue(`paytypes.${index}.payrate`, foundRate._id);
            }
          }
        }
      });
      currentPayslipstate.additions.forEach((addition, index) => {
        setValue(`additions.${index}.addition`, addition.addition._id);
        setValue(`additions.${index}.amount`, addition.amount);
      });
      currentPayslipstate.deductions.forEach((deduction, index) => {
        setValue(`deductions.${index}.deduction`, deduction.deduction._id);
        setValue(`deductions.${index}.amount`, deduction.amount);
      });

    }
  }, [currentPayslipstate, payratestate, reset, setValue]);


  useEffect(() => {
    if (currentPayslipstate) {
      if (currentPayslipstate?.paytypes) {
        const paytypestotal = currentPayslipstate.paytypes.reduce((acc, type) => {
          let rate = type.payrate?.rate || 0;
          let factor = type.paytype?.factor || 1;
          let hours = type.normalHours || 0;
          return acc + rate * factor * hours;
        }, 0).toFixed(2);

        setGrandTotal(paytypestotal);
      }
      if (currentPayslipstate?.deductions) {
        const total = currentPayslipstate.deductions.reduce((acc, type) => {
          let amount = type?.amount || 0;
          return acc + amount;
        }, 0).toFixed(2);

        setDeductionTotal(total);
      }
      if (currentPayslipstate?.additions) {
        const additionstotal = currentPayslipstate.additions.reduce((acc, type) => {
          let amount = type?.amount || 0;
          return acc + amount;
        }, 0).toFixed(2);

        setAdditionTotal(additionstotal);
      }

      setTax(calculateTax());
      setUif(calculateUif());
      setNetpay(calculatenetpay());
    }
  }, [currentPayslipstate, reset, setValue]);

  const taxableIncome = currentPayslipstate.paytypes?.reduce((acc, type) => {
    let rate = type.payrate?.rate || 0;
    let factor = type.paytype?.factor || 1;
    let hours = type.normalHours || 0;
    return acc + rate * factor * hours;
  }, 0).toFixed(2);

  const taxAdditions = currentPayslipstate.additions?.reduce((acc, type) => {

    let amount = type?.amount || 0;
    return acc + amount;
  }, 0).toFixed(2);

  const taxDeductions = currentPayslipstate.deductions?.reduce((acc, type) => {
    let amount = type?.amount || 0;
    return acc + amount;
  }, 0).toFixed(2);

  const calculateTax = () => {
    console.log("Income " + taxableIncome)
    console.log("Additions " + taxAdditions)
    console.log("Deductions " + taxDeductions)

    var tax = 0
    var grosspay = (Number(taxableIncome) + Number(taxAdditions) - Number(taxDeductions))

    if (grosspay * 12 < 95750) {
      tax = 0
    } else if (grosspay * 12 < 237100) {
      tax = ((grosspay * 12 * .18) - 17235) / 12
    } else if (grosspay * 12 < 370500) {
      tax = (((grosspay * 12 - 237100) * .26) + 42678 - 17235) / 12
    } else if (grosspay * 12 < 512800) {
      tax = (((grosspay * 12 - 370500) * .31) + 77362 - 17235) / 12
    } else if (grosspay * 12 < 673000) {
      tax = (((grosspay * 12 - 512800) * .36) + 121475 - 17235) / 12
    } else if (grosspay * 12 < 857900) {
      tax = (((grosspay * 12 - 673000) * .39) + 179147 - 17235) / 12
    } else if (grosspay * 12 < 1817000) {
      tax = (((grosspay * 12 - 857900) * .41) + 251258 - 17235) / 12
    } else if (grosspay * 12 > 1817000) {
      tax = (((grosspay * 12 - 1817000) * .45) + 644489 - 17235) / 12
    }


    return tax.toFixed(2)
  }
  const calculateUif = () => {
    console.log("Income " + taxableIncome)
    console.log("Additions " + taxAdditions)
    console.log("Deductions " + taxDeductions)

    var uif = 0
    var grosspay = (Number(taxableIncome) + Number(taxAdditions) - Number(taxDeductions))

    if (grosspay * 0.01 < 177.12) {
      uif = grosspay * 0.01
    } else {
      uif = 177.12
    }
    return uif.toFixed(2)
  }
  const calculatenetpay = () => {

    return (Number(grandTotal) + Number(additionTotal) - Number(deductionTotal) - Number(tax) - Number(uif)).toFixed(2)
  }
  const removePaytype = (indexToRemove) => {
    currentPayslipsetState((prevState) => {
      console.log("Removing index:", indexToRemove); // Debugging line

      return {
        ...prevState,
        currentPayslip: {
          ...prevState.currentPayslip,
          paytypes: prevState.paytypes.filter((_, index) => index !== indexToRemove),
        },
      };
    });
  };
  const removeAddition = (indexToRemove) => {
    currentPayslipsetState((prevState) => {
      console.log("Removing index:", indexToRemove); // Debugging line

      return {
        ...prevState,
        standardPayslip: {
          ...prevState.standardPayslip,
          additions: prevState.standardPayslip.additions.filter((_, index) => index !== indexToRemove),
        },
      };
    });
  };
  const removeDeduction = (indexToRemove) => {
    currentPayslipsetState((prevState) => {
      console.log("Removing index:", indexToRemove); // Debugging line

      return {
        ...prevState,
        standardPayslip: {
          ...prevState.standardPayslip,
          deductions: prevState.standardPayslip.deductions.filter((_, index) => index !== indexToRemove),
        },
      };
    });
  };
  const handleEdit = () => {
    setEdit((prev) => !prev)
  }
  const onSubmit = async (data) => {

    console.log("submit gekliek")

    console.log(currentPayslipstate)
    console.log(data)



    try {
      const response = await axios.patch(`${CURRENTPAYSLIPS_URL}/${id}`,
        JSON.stringify({ data: data }),
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + accessToken

          }
        }
      );


      console.log(response)
      setEdit(false)
      setPayOpen(false)
      setErrMessage("")
      currentPayslipsetTrigger(true)

    } catch (error) {

      if (!error.response) {
        setErrMessage("No server response")
      } else if (error.response?.status === 400) {
        setErrMessage("Missing data")
      } else if (error.status === 500) {
        console.log(error.message)
        setErrMessage(error.message + " " + error.response?.data?.msg?.message)
      } else {
        setErrMessage('failed')
      }
      console.log(error)
    }






  }
  const createNew = async (data) => {

    console.log("create gekliek")


    console.log(currentPayrunliststate)

    if (currentPayrunliststate.currentPayslips.find(val => val.employee._id === data.employee)) {

      setDuplicate(true)
      return

    }

    console.log(data)

    const createdata = [{ ...data, date: new Date() }]

    console.log(createdata)


    try {
      const response = await axios.post(`${CURRENTPAYSLIPS_URL}`,
        JSON.stringify({ data: createdata }),
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + accessToken

          }
        }
      );


      console.log(response)
      // navigate('../PayrunList')
    } catch (error) {

      if (!error.response) {
        setErrMessage("No server response")
      } else if (error.response?.status === 400) {
        setErrMessage("Missing data")
      } else if (error.status === 500) {
        console.log(error.message)
        setErrMessage(error.message + " " + error.response?.data?.msg?.message)
      } else {
        setErrMessage('failed')
      }
      console.log(error)
    }






  }

  return (
    <>

      <Header username={username} role={access} destination={'../PayrunList'}></Header>
      <div className=''>

        {newPayslip ?

          <>
            {duplicate &&

              <div>Hierdie employee het reeds 'n Current Payslip</div>
            }

            <form onSubmit={handleSubmit(createNew)}>


              <label>Choose an employee for new Payslip </label>
              <select
                className="inputsize"

                {...register(`employee`, { required: 'Paytype is required' })}
              >
                <option value=''>select</option> {/* Default option */}

                {state?.employees?.map((employee) => (
                  <option key={employee._id} value={employee._id}>
                    {employee.givname + " " + employee.surname}
                  </option>
                ))}
              </select>
              <p className='error'>{errors.paytype?.message}</p>

              <Knoppie text={"Submit"} callback={handleSubmit(createNew)}></Knoppie>

            </form>

          </>


          :
          <>
            <div className='PayslipLineItem'>
              <div>{currentPayslipstate.employee?.dept}</div>
        
                <div>{currentPayslipstate.employee?.givname}</div>
                <div>{currentPayslipstate.employee?.surname}</div>
              
            </div>

            <div className='PayslipBody'>
              {!edit ?

                //****************     Payslip     ***************************************** 
                (<>
                  <Knoppie
                    text={"Edit payslip"}
                    callback={handleEdit}
                  ></Knoppie>

                  <div>Income</div>

                  <div className='PayslipLineItem Heading'>
                    <div className='PayslipText'>Total Income</div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div className='PayslipNumbers'>{grandTotal}</div>
                  </div>

                  {currentPayslipstate.paytypes?.map((type) => {

                    const rate = type.payrate?.rate
                    const factor = type.paytype?.factor
                    const hours = type.normalHours
                    const total = (rate * factor * hours).toFixed(2)


                    return (
                      <>
                        <div className='PayslipLineItem'>
                          <div className='PayslipText'>{type.paytype?.description}</div>
                          <div className='PayslipNumbers'>{type.normalHours}</div>
                          <div className='PayslipNumbers'>{type.paytype?.factor}</div>
                          <div className='PayslipNumbers'>{type.payrate?.rate}</div>
                          <div className='PayslipNumbers'>{total}</div>
                        </div>

                      </>
                    )
                  })}
                  <div>Additions</div>
                  <div className='PayslipLineItem Heading'>
                    <div className='PayslipText'>Total Additions</div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div className='PayslipNumbers'>{additionTotal}</div>
                  </div>
                  {currentPayslipstate.additions?.map((addition) => {



                    return (
                      <>
                        <div className='AdditionLineitem'>
                          <div className='PayslipText'>{addition.addition.code}</div>
                          <div className='PayslipText'>{addition.addition.description}</div>
                          <div></div>
                          <div></div>
                          <div className='PayslipNumbers'>{addition.amount}</div>

                        </div>

                      </>
                    )
                  })}

                  <div>Deductions</div>

                  <div className='PayslipLineItem Heading'>
                    <div className='PayslipText'>Total Deductions</div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div className='PayslipNumbers'>{deductionTotal}</div>
                  </div>

                  {currentPayslipstate?.deductions?.map((deduction) => {



                    return (
                      <>
                        <div className='AdditionLineitem'>
                          <div className='PayslipText'>{deduction.deduction.code}</div>
                          <div className='PayslipText'>{deduction.deduction.description}</div>
                          <div></div>
                          <div></div>
                          <div className='PayslipNumbers'>{deduction.amount}</div>

                        </div>

                      </>
                    )
                  })}

                  <div className='PayslipLineItem Heading'>
                    <div className='PayslipText'>Tax</div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div className='PayslipNumbers'>{tax}</div>
                  </div>
                  <div className='PayslipLineItem Heading'>
                    <div className='PayslipText'>Uif</div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div className='PayslipNumbers'>{uif}</div>
                  </div>
                  <div className='PayslipLineItem Heading'>
                    <div className='PayslipText'>Net Pay</div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div className='PayslipNumbers'>{netpay}</div>
                  </div>
                </>
                )
                :

                //****************   Payslip when Edit is open     **************************************************************
                (<>
                  <Knoppie
                    text={"Cancel"}
                    setPayOpen={false}
                    callback={handleEdit}
                  ></Knoppie>





                  {errMessage !== "" ? <div>{errMessage}</div> : ""}

                  <form onSubmit={handleSubmit(onSubmit)}>

                    <Knoppie text={"Add paytype"} callback={() => setPayOpen((prev) => !prev)}></Knoppie>
                    <div>Income</div>
                    {currentPayslipstate.paytypes.map((type, index) => {

                      const normalHours = watch(`paytypes.${index}.normalHours`);
                      const selectedBaseRate = watch(`paytypes.${index}.payrate`); // Watch basepayrate
                      const baseRate = payratestate?.payrates?.find(payrate => payrate?._id === selectedBaseRate)?.rate || 0;
                      const total = (normalHours * baseRate).toFixed(2);

                      return (



                        <div className='PayslipLineItem' key={index}>

                          <select
                            className="inputsize"

                            {...register(`paytypes.${index}.paytype`, { required: 'Paytype is required' })}
                          >
                            <option value=''>select</option> {/* Default option */}

                            {paytypestate?.paytypes?.map((paytype) => (
                              <option key={paytype?._id} value={paytype?._id}>
                                {paytype?.description}
                              </option>
                            ))}
                          </select>
                          <p className='error'>{errors.paytype?.message}</p>
                          <input type={"number"}
                            className="inputsize"
                            {...register(`paytypes.${index}.normalHours`)}
                          />
                          <select
                            className="inputsize"

                            {...register(`paytypes.${index}.payrate`, { required: 'Baserate is required' })}
                          >
                            <option value=''>select</option> {/* Default option */}

                            {payratestate?.payrates?.map((payrate) => (
                              <option key={payrate?._id} value={payrate?._id}>
                                {payrate.rate}
                              </option>
                            ))}
                          </select>
                          <p className='error'>{errors.payrate?.message}</p>

                          <div>{total}</div>

                          <Knoppie text={"Remove"} callback={() => removePaytype(index)}></Knoppie>
                        </div>
                      )
                    })}
                    {payOpen &&
                      <div className='PayslipLineItem' key={currentPayslipstate.paytypes.length}>

                        <select
                          className="inputsize"

                          {...register(`paytypes.${currentPayslipstate.paytypes.length}.paytype`, { required: 'Paytype is required' })}
                        >
                          <option value=''


                          >select</option> {/* Default option */}

                          {paytypestate?.paytypes?.map((paytype) => (
                            <option key={paytype._id} value={paytype._id}>
                              {paytype.description}
                            </option>
                          ))}
                        </select>
                        <p className='error'>{errors.paytype?.message}</p>
                        <input type={"number"}

                          {...register(`paytypes.${currentPayslipstate.paytypes.length}.normalHours`)}
                        />
                        <select
                          className="inputsize"
                          defaultValue={
                            payratestate.payrates?.find(val => val.code === currentPayslipstate.employee.baserate)?._id || ""
                          }
                          {...register(`paytypes.${currentPayslipstate.paytypes.length}.payrate`, { required: 'Baserate is required' })}
                        >
                          <option value=''

                          >select</option> {/* Default option */}

                          {payratestate?.payrates?.map((payrate) => (
                            <option key={payrate._id} value={payrate._id}>


                              <div>{payrate.rate + "   " + payrate.code}</div>



                            </option>
                          ))}
                        </select>
                        <p className='error'>{errors.payrate?.message}</p>




                        <Knoppie text={"Remove"} callback={() => removePaytype(currentPayslipstate.paytypes.length)}></Knoppie>
                      </div>
                    }
                    <Knoppie text={"Add Addition"} callback={() => setAdditionOpen((prev) => !prev)}></Knoppie>

                    <div>Additions</div>
                    {currentPayslipstate.additions.map((addition, index) => {



                      return (



                        <div className='PayslipLineItem' key={index}>

                          <select
                            className="inputsize"

                            {...register(`additions.${index}.addition`, { required: 'Addition is required' })}
                          >
                            <option value=''>select</option> {/* Default option */}

                            {additionstate?.additions?.map((addition) => (
                              <option key={addition._id} value={addition._id}>
                                {addition.description}
                              </option>
                            ))}
                          </select>
                          <p className='error'>{errors.addition?.message}</p>
                          <input type={"number"}

                            {...register(`additions.${index}.amount`)}
                          />

                          <Knoppie text={"Remove"} callback={() => removeAddition(index)}></Knoppie>
                        </div>
                      )
                    })}

                    {
                      additionOpen &&
                      <div className='PayslipLineItem' key={currentPayslipstate.additions.length}>

                        <select
                          className="inputsize"

                          {...register(`additions.${currentPayslipstate.additions.length}.addition`, { required: 'Addition is required' })}
                        >
                          <option value=''>select</option> {/* Default option */}

                          {additionstate?.additions?.map((addition) => (
                            <option key={addition._id} value={addition._id}>
                              {addition.description}
                            </option>
                          ))}
                        </select>
                        <p className='error'>{errors.addition?.message}</p>
                        <input type={"number"}

                          {...register(`additions.${currentPayslipstate.additions.length}.amount`)}
                        />





                        <Knoppie text={"Remove"} callback={() => removePaytype(currentPayslipstate.paytypes.length)}></Knoppie>
                      </div>
                    }


                    <Knoppie text={"Add Deduction"} callback={() => setDeductionOpen((prev) => !prev)}></Knoppie>

                    <div>Deductions</div>
                    {currentPayslipstate.deductions.map((deduction, index) => {

                      return (

                        <div className='PayslipLineItem' key={index}>

                          <select
                            className="inputsize"

                            {...register(`standardPayslip.deductions.${index}.deduction`, { required: 'deduction is required' })}
                          >
                            <option value=''>select</option> {/* Default option */}

                            {additionstate?.additions?.map((addition) => (
                              <option key={addition._id} value={addition._id}>
                                {addition.description}
                              </option>
                            ))}
                          </select>
                          <p className='error'>{errors.addition?.message}</p>
                          <input type={"number"}

                            {...register(`standardPayslip.deductions.${index}.amount`)}
                          />

                          <Knoppie text={"Remove"} callback={() => removeDeduction(index)}></Knoppie>
                        </div>
                      )
                    })}

                    {
                      deductionOpen &&
                      <div className='PayslipLineItem' key={currentPayslipstate.deductions.length}>

                        <select
                          className="inputsize"

                          {...register(`deductions.${currentPayslipstate.deductions.length}.deduction`, { required: 'Addition is required' })}
                        >
                          <option value=''>select</option> {/* Default option */}

                          {additionstate?.additions?.map((addition) => (
                            <option key={addition._id} value={addition._id}>
                              {addition.description}
                            </option>
                          ))}
                        </select>
                        <p className='error'>{errors.addition?.message}</p>
                        <input type={"number"}

                          {...register(`deductions.${currentPayslipstate.additions.length}.amount`)}
                        />





                        <Knoppie text={"Remove"} callback={() => removeDeduction(currentPayslipstate.standardPayslip?.deductions.length)}></Knoppie>
                      </div>
                    }

                    <Knoppie text={"Submit"} callback={handleSubmit(onSubmit)}></Knoppie>

                  </form>
                </>
                )

              }

            </div>
          </>
        }


      </div >


    </>
  );
};

export default CurrentPayslip;

